import { jsxs as C, jsx as u } from "react/jsx-runtime";
import { c as V } from "./clsx-OuTLNxxd.js";
import * as q from "react";
import Z, { useContext as $, useRef as j, useState as S, useMemo as k, useEffect as b, cloneElement as G } from "react";
import { M as D, d as x, a as H, P as J, N as Q, b as w } from "./popup-DCSSyJs_.js";
import { useMap as W } from "./components/elements/map/map.hook.js";
function L(t, e) {
  if (!t)
    throw new Error(e);
}
let X = 0;
function Y(t, e, o) {
  if (t.style && t.style._loaded) {
    const n = { ...o };
    return delete n.id, delete n.children, t.addSource(e, n), t.getSource(e);
  }
  return null;
}
function v(t, e, o) {
  L(e.id === o.id, "source id changed"), L(e.type === o.type, "source type changed");
  let n = "", l = 0;
  for (const a in e)
    a !== "children" && a !== "id" && !x(o[a], e[a]) && (n = a, l++);
  if (!l)
    return;
  const i = e.type;
  if (i === "geojson")
    t.setData(e.data);
  else if (i === "image")
    t.updateImage({
      url: e.url,
      coordinates: e.coordinates
    });
  else
    switch (n) {
      case "coordinates":
        t.setCoordinates?.(e.coordinates);
        break;
      case "url":
        t.setUrl?.(e.url);
        break;
      case "tiles":
        t.setTiles?.(e.tiles);
        break;
      default:
        console.warn(`Unable to update <Source> prop: ${n}`);
    }
}
function p(t) {
  const e = $(D).map.getMap(), o = j(t), [, n] = S(0), l = k(() => t.id || `jsx-source-${X++}`, []);
  b(() => {
    if (e) {
      const a = () => setTimeout(() => n((s) => s + 1), 0);
      return e.on("styledata", a), a(), () => {
        if (e.off("styledata", a), e.style && e.style._loaded && e.getSource(l)) {
          const s = e.getStyle()?.layers;
          if (s)
            for (const c of s)
              c.source === l && e.removeLayer(c.id);
          e.removeSource(l);
        }
      };
    }
  }, [e]);
  let i = e && e.style && e.getSource(l);
  return i ? v(i, t, o.current) : i = Y(e, l, t), o.current = t, i && q.Children.map(t.children, (a) => a && G(a, {
    source: l
  })) || null;
}
function ee(t, e, o, n) {
  if (L(o.id === n.id, "layer id changed"), L(o.type === n.type, "layer type changed"), o.type === "custom" || n.type === "custom")
    return;
  const { layout: l = {}, paint: i = {}, filter: a, minzoom: s, maxzoom: c, beforeId: y } = o;
  if (y !== n.beforeId && t.moveLayer(e, y), l !== n.layout) {
    const d = n.layout || {};
    for (const r in l)
      x(l[r], d[r]) || t.setLayoutProperty(e, r, l[r]);
    for (const r in d)
      l.hasOwnProperty(r) || t.setLayoutProperty(e, r, void 0);
  }
  if (i !== n.paint) {
    const d = n.paint || {};
    for (const r in i)
      x(i[r], d[r]) || t.setPaintProperty(e, r, i[r]);
    for (const r in d)
      i.hasOwnProperty(r) || t.setPaintProperty(e, r, void 0);
  }
  x(a, n.filter) || t.setFilter(e, a), (s !== n.minzoom || c !== n.maxzoom) && t.setLayerZoomRange(e, s, c);
}
function te(t, e, o) {
  if (t.style && t.style._loaded && (!("source" in o) || t.getSource(o.source))) {
    const n = { ...o, id: e };
    delete n.beforeId, t.addLayer(n, o.beforeId);
  }
}
let ne = 0;
function R(t) {
  const e = $(D).map.getMap(), o = j(t), [, n] = S(0), l = k(() => t.id || `jsx-layer-${ne++}`, []);
  if (b(() => {
    if (e) {
      const a = () => n((s) => s + 1);
      return e.on("styledata", a), a(), () => {
        e.off("styledata", a), e.style && e.style._loaded && e.getLayer(l) && e.removeLayer(l);
      };
    }
  }, [e]), e && e.style && e.getLayer(l))
    try {
      ee(e, l, t, o.current);
    } catch (a) {
      console.warn(a);
    }
  else
    te(e, l, t);
  return o.current = t, null;
}
const E = "#f7a800";
function oe({
  longitude: t,
  latitude: e,
  radiusInMeters: o,
  color: n = "primary",
  opacity: l = 0.2,
  strokeWidth: i = 2
}) {
  const [a, s] = S(E);
  b(() => {
    const d = getComputedStyle(document.documentElement);
    s(d.getPropertyValue(`--color-${n}`) || E);
  }, [n]);
  const c = Array.from({ length: 64 }, (d, r) => {
    const m = r / 64 * 2 * Math.PI, M = e + o / I * Math.cos(m);
    return [t + o / (I * Math.cos(e * Math.PI / 180)) * Math.sin(m), M];
  });
  return c.push(c[0]), /* @__PURE__ */ C(p, { type: "geojson", data: {
    type: "Feature",
    geometry: {
      type: "Polygon",
      coordinates: [c]
    },
    properties: {}
  }, children: [
    /* @__PURE__ */ u(
      R,
      {
        type: "fill",
        paint: {
          "fill-color": a,
          "fill-opacity": l
        }
      }
    ),
    /* @__PURE__ */ u(
      R,
      {
        type: "line",
        paint: {
          "line-color": a,
          "line-width": i
        }
      }
    )
  ] });
}
const z = {
  "map-container": "_map-container_1ixlk_29",
  "center-marker": "_center-marker_1ixlk_35"
}, I = 111320, ae = Z.forwardRef(
  ({
    initialViewState: t = {
      longitude: 2.3522,
      latitude: 48.8566,
      zoom: 13
    },
    bounds: e,
    circleLayer: o,
    markers: n,
    singleMarker: l,
    popup: i,
    mapStyle: a,
    padding: s,
    className: c,
    onMoveEnd: y,
    onDragEnd: d,
    onResize: r,
    positionNavControl: m = "top-left",
    maxZoom: M = 19,
    minZoom: _ = 0,
    randomPosition: N = !1,
    id: O = "1",
    centerMarker: h,
    debounceEventsTime: P = 300
  }, U) => {
    const { mapRef: B, singleMarker: g, handleMoveEnd: A, handleDragEnd: F, handleResize: K, handleMapLoad: T } = W({
      initialSingleMarker: l,
      randomPosition: N,
      id: O,
      onMoveEnd: y,
      onDragEnd: d,
      onResize: r,
      ref: U,
      debounceEventsTime: P
    });
    return /* @__PURE__ */ C("div", { className: V(z["map-container"], c), children: [
      /* @__PURE__ */ C(
        H,
        {
          ref: B,
          initialViewState: {
            ...t,
            bounds: e,
            fitBoundsOptions: {
              padding: {
                top: s?.top ?? 10,
                bottom: s?.bottom ?? 10,
                left: s?.left ?? 10,
                right: s?.right ?? 10
              }
            }
          },
          mapStyle: a,
          dragRotate: !1,
          style: { width: "100%", height: "100%" },
          onMoveEnd: A,
          onResize: K,
          minZoom: _,
          maxZoom: M,
          onLoad: T,
          children: [
            o && /* @__PURE__ */ u(oe, { ...o }),
            i && /* @__PURE__ */ u(J, { ...i }),
            /* @__PURE__ */ u(Q, { showCompass: !1, position: m }),
            n && n.map((f) => /* @__PURE__ */ u(
              w,
              {
                longitude: f.longitude,
                latitude: f.latitude,
                draggable: f.draggable,
                style: { zIndex: f.indexPosition || 1 },
                children: f.content
              },
              `${f.longitude}-${f.latitude}`
            )),
            g && /* @__PURE__ */ u(
              w,
              {
                longitude: g.longitude,
                latitude: g.latitude,
                draggable: g.draggable,
                onDragEnd: F,
                children: g.content
              }
            )
          ]
        }
      ),
      h && /* @__PURE__ */ u(
        "div",
        {
          className: z["center-marker"],
          style: { transform: `translate(${h.offset?.x ?? 0}px, ${h.offset?.y ?? 0}px)` },
          children: h.content
        }
      )
    ] });
  }
);
ae.displayName = "MapBox";
export {
  oe as C,
  ae as M,
  I as O
};
